// RITA-1538: Anmeldung für Abrufe außerhalb von GraphQL, etwa die geschützten Dateien unter
// /files (Berater-Dokumente) und /accounting (Monatsabrechnung). Das Token kommt aus derselben
// Quelle wie bei den übrigen Aufrufen (getToken, localStorage). Ohne Token wird kein Kopf
// gesendet; der Server antwortet dann mit 401.
import { getToken } from '../../context/CommunicationProvider/authUser';

const authorizationHeader = (): Record<string, string> => {
  const token = getToken();
  return token ? { authorization: `Bearer ${token}` } : {};
};

export default authorizationHeader;
